import { readResponse } from '../../Kyousai/Api/readResponse';
const authentication = require('../../../react-azure-adb2c2').default;



export const update = (values: any) => {

    const token = authentication.getAccessToken();
    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts`;
    // let url = `http://localhost:5000/api/v1/rent/contracts`;

    return fetch(url, {
        method: 'put',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res)
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}



export const bind_kyousai = (values: any) => {

    const token = authentication.getAccessToken();
    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id
    console.log(values)


    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/bind/`;
    // let url = `http://localhost:5000/api/v1/rent/contracts/bind/`;

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    }).then(readResponse).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}


export const bind_kyousai_cancel = (values: any) => {

    const token = authentication.getAccessToken();
    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id
    console.log(values)


    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/bind/cancel`;
    // let url = `http://localhost:5000/api/v1/rent/contracts/bind/cancel`;
    // alert(url)
    // alert(JSON.stringify(values))
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    }).then(readResponse).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}




export const list = (values: any) => {


    // let url = `https://homestationapi.azurewebsites.net/api/RentContracts?moneyall=1`;

    // let url = `https://moniesapi.azurewebsites.net/api/v1/rent/contracts/search`;

    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/search/`;
    // let url = `http://localhost:5000/api/v1/rent/contracts/search/`;

    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};














export const detail = (Id: number) => {

    const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + Id;

    const token = authentication.getAccessToken();

    return fetch(url, {
        headers: { 'Authorization': 'Bearer ' + token }
    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}



